import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from './../assets/VE_Symbol.png'


const _hoisted_1 = { class: "h-dvh" }
const _hoisted_2 = { class: "h-dvh" }
const _hoisted_3 = { class: "grid h-dvh place-items-center bg-gradient-to-r from-gray-700 to-gray-800" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-28 w-auto",
  src: _imports_0,
  alt: "Your Company"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "mt-4 text-gray-200 hidden font-bold tracking-tight text-7xl sm:block" }, "hyperLayer", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "mt-5 flex items-center justify-center gap-x-6" }

import { computed, onMounted, ref } from "@vue/runtime-core";
import { authStore } from "../store/index";
import { useRouter, useRoute } from 'vue-router'
import ProgressSpinner from 'primevue/progressspinner';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter()
const auth = authStore();
onMounted(async () => {
  if (auth.tokenValid) {
    router.push("/statsearch")
  }
});

const isClicked = ref(false)

function Login() {
  isClicked.value = true
  auth.login().then((e)=>{
    router.push("/statsearch")
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("html", _hoisted_1, [
    _createElementVNode("body", _hoisted_2, [
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex", { 'animate-[rise_1.5s_ease-in-out_forwards]': _unref(isClicked) }])
          }, _hoisted_7, 2),
          _createElementVNode("div", _hoisted_8, [
            (!_unref(isClicked))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "rounded-md bg-[#36a8dd] px-5 py-1 text-lg text-gray-200 shadow-sm hover:bg-sky-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
                  onClick: Login
                }, " Login"))
              : (_openBlock(), _createBlock(_unref(ProgressSpinner), {
                  key: 1,
                  class: "absolute h-90 w-90",
                  "attrs-color-black": "",
                  strokeWidth: "5",
                  animationDuration: "1s",
                  "aria-label": "Loading"
                }))
          ])
        ])
      ])
    ])
  ]))
}
}

})